const DOMAIN = "https://shopifyconnect.wolfestonegroup.co.uk:444";

export default DOMAIN;
